import styles from './VehicleLocationBar.module.css';

function VehicleLocationBar({
  loading = false,
  location = null,
  onClose
}) {
  const locationText = (() => {
    if (!location) {
      return 'Ubicación disponible';
    }

    /*
      Si Google encontró una dirección concreta,
      mostramos únicamente:

      Dirección · Ciudad · País

      No usamos sector, departamento ni
      referencia cercana para evitar redundancia.
    */
    if (location.street) {
      const parts = [
        location.street,
        location.city,
        location.country
      ]
        .filter(Boolean)
        .filter(
          (value, index, array) =>
            array.findIndex(
              (item) =>
                String(item).toLowerCase() ===
                String(value).toLowerCase()
            ) === index
        );

      return parts.join(' · ');
    }

    /*
      Si Google no pudo separar la calle,
      utilizamos su dirección formateada
      completa sin volver a agregar ciudad
      o país para no repetir información.
    */
    if (location.formattedAddress) {
      return location.formattedAddress;
    }

    return [
      location.city,
      location.country
    ]
      .filter(Boolean)
      .join(' · ') ||
      'Ubicación disponible';
  })();

  return (
    <div className={styles.bar}>
      <div className={styles.locationIcon}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M12 22s7-6.4 7-13a7 7 0 1 0-14 0c0 6.6 7 13 7 13Z"
            fill="currentColor"
          />

          <circle
            cx="12"
            cy="9"
            r="2.7"
            fill="#07366f"
          />
        </svg>
      </div>

      <div className={styles.addressBlock}>
        {loading ? (
          <div className={styles.loadingTitle}>
            Obteniendo ubicación...
          </div>
        ) : (
          <div className={styles.mainAddress}>
            {locationText}
          </div>
        )}
      </div>

      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Cerrar ubicación"
      >
        ×
      </button>
    </div>
  );
}

export default VehicleLocationBar;